import React from 'react';
import {
  Container
} from 'react-bootstrap';
import { Tron } from './Tron';

export const CurrentIssues = () => {
  
  let homeTron = {
    title: 'Workspace ONE Excel Add-In (Beta)',
    description: 'This is the Current Issues Page  for the Workspace ONE Excel Add-In.',
    body: <></>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        <p>Contact <a href="mailto:lettol@vmware.com">Leon Letto</a> if you are having issue other than the ones listed
          here</p>
        <h2>Current Issues List</h2>
        <br/>
        <h3>All Platforms</h3>
        <ul>
          <li>If you run this using the default configuration without implementing the <a href='/APIBackendWindows'>Caching
            API</a> in a large environment it takes a while for some of the queries to come back.
            Especially if you click “Get Current App Devices” it has to do an API call for each device
            the app is installed on so it can take a while.
            Eg. in a large environment where they have acrobat deployed to 3000 devices it takes about 5
            minutes. This delay is for the first time running reports since the device list is cached in the
            app. So, the next time you run the report it will only do API calls for devices which are new.
            <p>Please use the <a href='/APIBackendWindows'>Caching API</a>. It takes about 30 minutes to setup and your
              performance will be improved 100x.</p>
          </li>
        
        </ul>
      
      </Container>
    </Container>
  );
};

